import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import WhatWeBuild from "@/components/WhatWeBuild";
import Roadmap from "@/components/Roadmap";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => {
  useEffect(() => {
    document.title =
      "Laiv Ai — Vibecast: Streaming for Tech Professionals";
  }, []);

  return (
    <div className="App" data-testid="laiv-home">
      <Navbar />
      <main>
        <Hero />
        <WhatWeBuild />
        <About />
        <Roadmap />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
